(function () {
  'use strict';

  function money(amount) {
    if (typeof amount === 'string') {
      if (amount.indexOf('$') > -1 || amount.indexOf('R$') > -1) return amount;
      amount = parseFloat(amount);
    }

    if (!window.isFinite(amount)) amount = 0;

    return amount.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var context = this;
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  document.querySelectorAll('[data-powerflow-inline-search]').forEach(function (root) {
    var form = root.querySelector('form');
    var input = root.querySelector('[data-powerflow-search-input]');
    var panel = root.querySelector('[data-powerflow-search-panel]');
    var status = root.querySelector('[data-powerflow-search-status]');
    var results = root.querySelector('[data-powerflow-search-results]');
    var predictiveUrl = root.getAttribute('data-predictive-url');
    var limit = root.getAttribute('data-limit') || '6';
    var abortController;

    if (!form || !input || !panel || !status || !results || !predictiveUrl) return;

    function openPanel() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      if (abortController) abortController.abort();
      panel.hidden = true;
      status.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    }

    function renderProducts(products) {
      if (!products.length) {
        results.innerHTML = '<p class="powerflow-inline-search__empty">Nenhum produto encontrado</p>';
        return;
      }

      results.innerHTML = '<div class="powerflow-inline-search__list" role="listbox">' + products.map(function (product) {
        var image = product.image || product.featured_image || {};
        var imageUrl = typeof image === 'string' ? image : image.url;
        var separator = imageUrl && imageUrl.indexOf('?') > -1 ? '&' : '?';
        var title = escapeHtml(product.title);
        var imageMarkup = imageUrl
          ? '<img src="' + imageUrl + separator + 'width=104" alt="' + title + '" loading="lazy">'
          : '<span aria-hidden="true">Produto</span>';
        var price = product.price_min || product.price || 0;
        var productUrl = product.url || '#';

        return '<div class="powerflow-inline-search__item" role="option">' +
          '<a class="powerflow-inline-search__link" href="' + productUrl + '">' +
            '<span class="powerflow-inline-search__thumb">' + imageMarkup + '</span>' +
            '<span class="powerflow-inline-search__copy">' +
              '<span class="powerflow-inline-search__title">' + title + '</span>' +
              '<span class="powerflow-inline-search__price">' + money(price) + '</span>' +
            '</span>' +
          '</a>' +
        '</div>';
      }).join('') + '</div>';
    }

    var fetchResults = debounce(function () {
      var term = input.value.trim();
      var url;

      if (term.length < 2) {
        results.innerHTML = '';
        closePanel();
        return;
      }

      if (abortController) abortController.abort();
      abortController = new window.AbortController();
      status.hidden = false;
      results.innerHTML = '';
      openPanel();

      url = new URL(predictiveUrl, window.location.origin);
      url.searchParams.set('q', term);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', limit);
      url.searchParams.set('options[prefix]', 'last');

      window.fetch(url.toString(), {
        signal: abortController.signal,
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.json();
        })
        .then(function (payload) {
          var products = payload.resources && payload.resources.results && payload.resources.results.products
            ? payload.resources.results.products
            : [];
          status.hidden = true;
          renderProducts(products);
          openPanel();
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          status.hidden = true;
          results.innerHTML = '<p class="powerflow-inline-search__empty">Nenhum produto encontrado</p>';
          openPanel();
        });
    }, 300);

    input.addEventListener('input', fetchResults);
    input.addEventListener('focus', function () {
      if (results.innerHTML.trim()) openPanel();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) closePanel();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closePanel();
    });
  });

  document.querySelectorAll('[data-powerflow-support]').forEach(function (root) {
    var toggle = root.querySelector('[data-powerflow-support-toggle]');
    var panel = root.querySelector('[data-powerflow-support-panel]');
    var form = root.querySelector('[data-powerflow-tracking-form]');
    var input = root.querySelector('[data-powerflow-tracking-input]');
    var error = root.querySelector('[data-powerflow-tracking-error]');
    var closeTimer;

    if (!toggle || !panel) return;

    function open() {
      window.clearTimeout(closeTimer);
      panel.hidden = false;
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function close() {
      panel.hidden = true;
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      panel.hidden ? open() : close();
    });

    root.addEventListener('mouseenter', open);
    root.addEventListener('mouseleave', function () {
      closeTimer = window.setTimeout(close, 120);
    });

    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) close();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    if (form && input) {
      form.addEventListener('submit', function (event) {
        var code = input.value.trim();
        var trackingUrl = root.getAttribute('data-tracking-url') || '';
        var queryParam = root.getAttribute('data-tracking-query-param') || 'objeto';
        event.preventDefault();

        if (!code) {
          if (error) error.hidden = false;
          input.focus();
          return;
        }

        if (error) error.hidden = true;
        window.location.href = trackingUrl + '?' + encodeURIComponent(queryParam) + '=' + encodeURIComponent(code);
      });

      input.addEventListener('input', function () {
        if (error && input.value.trim()) error.hidden = true;
      });
    }
  });

  document.querySelectorAll('[data-powerflow-pdp-shipping]').forEach(function (root) {
    var form = root.querySelector('[data-powerflow-shipping-form]');
    var input = root.querySelector('[name="postal_code"]');
    var button = root.querySelector('[type="submit"]');
    var notice = root.querySelector('[data-powerflow-shipping-notice]');
    var results = root.querySelector('.powerflow-pdp-shipping-calculator__results');
    var productId = root.getAttribute('data-product-id');
    var workerUrl = root.getAttribute('data-worker-url');
    var sellerCep = root.getAttribute('data-seller-cep');
    var abortController;
    var activeVariant;

    if (!form || !input || !button || !notice || !results || !productId || !workerUrl || !sellerCep) return;

    function showMessage(message, state) {
      results.classList.remove('is-success', 'is-error');
      if (state) results.classList.add('is-' + state);
      results.innerHTML = message;
      results.hidden = false;
    }

    function parseVariant(container) {
      var data = container && container.querySelector('[data-powerflow-shipping-variant]');
      if (!data) return null;

      try {
        return JSON.parse(data.textContent);
      }
      catch (error) {
        console.error('Invalid shipping variant data', error);
        return null;
      }
    }

    function hasShippingMeasurements(variant) {
      return ['height', 'width', 'length', 'weight'].every(function (key) {
        return Number.isFinite(Number(variant && variant[key])) && Number(variant[key]) > 0;
      });
    }

    function isEcoflowVariant(variant) {
      var vendor = String(variant && variant.vendor || '').trim().toLowerCase();
      var sku = String(variant && variant.sku || '').trim().toUpperCase();
      return vendor.indexOf('ecoflow') > -1 || sku.indexOf('ECF') === 0;
    }

    function resetRequest() {
      if (abortController) abortController.abort();
      abortController = null;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.querySelector('span').textContent = 'Calcular';
      results.hidden = true;
      results.innerHTML = '';
      results.classList.remove('is-success', 'is-error');
    }

    function applyVariant(variant) {
      activeVariant = variant;
      resetRequest();
      notice.classList.remove('is-free');

      if (isEcoflowVariant(variant)) {
        form.hidden = true;
        notice.textContent = 'Frete gr\u00e1tis para este produto.';
        notice.classList.add('is-free');
        notice.hidden = false;
        return;
      }

      if (!hasShippingMeasurements(variant)) {
        form.hidden = true;
        notice.textContent = 'Frete dispon\u00edvel no carrinho ou checkout.';
        notice.hidden = false;
        return;
      }

      notice.hidden = true;
      notice.textContent = '';
      form.hidden = false;
    }

    function renderRates(rates) {
      var rows = rates.map(function (rate) {
        var price = new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(Number(rate.preco) || 0);
        var deadline = Number(rate.prazo);
        var deadlineLabel = deadline === 1 ? '1 dia \u00fatil' : deadline + ' dias \u00fateis';

        return '<li class="powerflow-pdp-shipping-calculator__rate">' +
          '<span class="powerflow-pdp-shipping-calculator__rate-copy">' +
            '<strong>' + escapeHtml(rate.transportadora || 'Transportadora') + '</strong>' +
            '<span class="powerflow-pdp-shipping-calculator__rate-service">Entrega em até ' + escapeHtml(deadlineLabel) + '</span>' +
          '</span>' +
            '<strong class="powerflow-pdp-shipping-calculator__rate-price">' + price + '</strong>' +
        '</li>';
      }).join('');

      showMessage(
        '<p class="powerflow-pdp-shipping-calculator__intro">Op\u00e7\u00f5es de frete para o seu endere\u00e7o:</p>' +
        '<ul class="powerflow-pdp-shipping-calculator__rates">' + rows + '</ul>',
        'success'
      );
    }

    input.addEventListener('input', function () {
      var digits = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits;
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var zip = input.value.replace(/\D/g, '');

      if (zip.length !== 8) {
        showMessage('Digite um CEP v\u00e1lido com 8 n\u00fameros.', 'error');
        input.focus();
        return;
      }

      if (!activeVariant || !hasShippingMeasurements(activeVariant)) {
        applyVariant(activeVariant);
        return;
      }

      if (abortController) abortController.abort();
      var requestController = new window.AbortController();
      abortController = requestController;
      var requestedVariantId = activeVariant.id;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.querySelector('span').textContent = 'Calculando...';
      showMessage('Consultando as op\u00e7\u00f5es de entrega...', '');

      window.fetch(workerUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        signal: requestController.signal,
        body: JSON.stringify({
          sellerCep: sellerCep,
          recipientCep: zip,
          valor: Number(activeVariant.price),
          itens: [{
            Height: Number(activeVariant.height),
            Length: Number(activeVariant.length),
            Width: Number(activeVariant.width),
            Weight: Number(activeVariant.weight),
            Quantity: 1
          }]
        })
      })
        .then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok || payload.sucesso !== true) {
              throw new Error(payload.erro || 'N\u00e3o foi poss\u00edvel calcular o frete agora.');
            }
            return payload;
          });
        })
        .then(function (payload) {
          if (!activeVariant || String(activeVariant.id) !== String(requestedVariantId)) return;
          var rates = Array.isArray(payload.opcoes) ? payload.opcoes : [];
          if (!rates.length) {
            showMessage('N\u00e3o encontramos uma op\u00e7\u00e3o de frete para este CEP.', 'error');
            return;
          }
          renderRates(rates);
        })
        .catch(function (error) {
          if (error.name === 'AbortError') return;
          showMessage(escapeHtml(error.message || 'N\u00e3o foi poss\u00edvel calcular o frete agora.'), 'error');
        })
        .finally(function () {
          if (abortController !== requestController) return;
          if (!activeVariant || String(activeVariant.id) !== String(requestedVariantId)) return;
          abortController = null;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.querySelector('span').textContent = 'Calcular';
        });
    });

    applyVariant(parseVariant(root));

    if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, function (event) {
        if (!event || !event.data || String(event.data.productId) !== String(productId)) return;

        var updatedRoot = event.data.parsedHTML &&
          event.data.parsedHTML.querySelector('[data-powerflow-pdp-shipping][data-product-id="' + productId + '"]');
        applyVariant(parseVariant(updatedRoot));
      });
    }
  });

  document.querySelectorAll('[data-powerflow-main-nav]').forEach(function (root) {
    var toggle = root.querySelector('[data-powerflow-nav-toggle]');
    var submenuToggles = root.querySelectorAll('[data-powerflow-submenu-toggle]');
    var closeTimer;

    function clearCloseTimer() {
      if (!closeTimer) return;
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    function closeAllSubmenus(exceptItem) {
      clearCloseTimer();
      root.querySelectorAll('[data-powerflow-nav-item]').forEach(function (item) {
        var submenu = item.querySelector('[data-powerflow-submenu]');
        var button = item.querySelector('[data-powerflow-submenu-toggle]');
        if (!submenu || item === exceptItem) return;
        submenu.hidden = true;
        item.classList.remove('is-open');
        if (button) button.setAttribute('aria-expanded', 'false');
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = root.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (!isOpen) closeAllSubmenus();
      });
    }

    submenuToggles.forEach(function (button) {
      var item = button.closest('[data-powerflow-nav-item]');
      var submenu = item && item.querySelector('[data-powerflow-submenu]');
      if (!item || !submenu) return;

      button.addEventListener('click', function (event) {
        event.preventDefault();
        var willOpen = submenu.hidden;
        closeAllSubmenus(willOpen ? item : null);
        submenu.hidden = !willOpen;
        item.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });

      item.addEventListener('mouseenter', function () {
        if (window.innerWidth < 1024) return;
        clearCloseTimer();
        closeAllSubmenus(item);
        submenu.hidden = false;
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      });

      item.addEventListener('mouseleave', function () {
        if (window.innerWidth < 1024) return;
        clearCloseTimer();
        closeTimer = window.setTimeout(function () {
          submenu.hidden = true;
          item.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          closeTimer = null;
        }, 120);
      });
    });

    document.addEventListener('click', function (event) {
      if (root.contains(event.target)) return;
      closeAllSubmenus();
      root.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllSubmenus();
      root.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });
})();
